export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fa71ce4d66588d3b170124eb668ec3561580ff428&name=fetchTypeahead!'